// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"EventDetailMap_Wrapper__7AHLg"};